import * as types from '../actions/action-types';

const getInitialState = () => ({
  countries: [],
  addressId: '',
  selectedAddressCategory: 'UNKNOWN',
  addresses: window.start.addresses?.addresses
    ? {
      '': {addressId: '', country: ''},
    }
    : null,
  savedAddressIds: [],
  editedAddress: [],
  contactNumber: '',
  residentID: {
    newResidentID: '',
    useStoredID: true,
  },
  showSpinner: false,
  editedAddressIds: [],
  entryType: 'STANDARD',
});

const deliveryAddressListReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case types.DELIVERY_ADDRESS_SET_COUNTRIES:
      return {...state, countries: action.countries};
    case types.DELIVERY_ADDRESS_SELECT:
      return {
        ...state,
        addressId: action.addressId,
        selectedAddressId: action.selectedAddressId,
        selectedAddressCategory: action.selectedAddressCategory,
        contactNumber: state.addresses[action.addressId].contactNumber,
        residentID: {...state.residentID, useStoredID: true},
      };
    case types.DELIVERY_ADDRESS_ADD:
      return {
        ...state,
        addressId: action.addressId,
        addresses: {
          ...state.addresses,
          [action.addressId]: {addressId: action.addressId, selectedAddressCategory: action.selectedAddressCategory, ...action.values},
        },
        savedAddressIds: [...state.savedAddressIds, action.addressId],
      };
    case types.DELIVERY_ADDRESS_UPDATE_FIELD:
      const newState = {
        ...state,
        addresses: {
          ...state.addresses,
          [action.addressId]: {...state.addresses[action.addressId], [action.name]: action.value},
        },
      };
      if (action.name === 'country') {
        delete newState.addresses[action.addressId].county;
        delete newState.addresses[action.addressId].postCode;
      }
      return newState;
    case types.DELIVERY_ADDRESS_UPDATE_FIELD_IN_OVERLAY:
      return {
        ...state,
        editedAddress: {
          ...state.editedAddress,
          [action.addressId]: {...state.editedAddress[action.addressId], [action.name]: action.value},
        },
      };
    case types.UPDATE_EDITED_ADDRESS:
      return {
        ...state,
        editedAddress: {
          [action.addressId]: {...state.editedAddress[action.addressId], ...action.values},
        },
      };
    case types.RESET_EDITED_ADDRESS:
      return {
        ...state,
        editedAddress: getInitialState().editedAddress,
      };
    case types.SET_ADDRESS_AS_EDITED:
      return {
        ...state,
        editedAddressIds: [...state.editedAddressIds, action.addressId],
      };
    case types.RESET_DELIVERY_ADDRESSES:
      return {
        ...state,
        addressId: '',
        addresses: {
          '': {addressId: '', country: action.deliveryCountry},
        },
        savedAddressIds: [],
      };
    case types.DELIVERY_ADDRESS_UPDATE_FIELDS:
      return {
        ...state,
        addresses: {
          ...state.addresses,
          [action.addressId]: {...state.addresses[action.addressId], ...action.values},
        },
      };
    case types.DELIVERY_ADDRESS_OVERWRITE:
      return {
        ...state,
        addresses: {
          ...state.addresses,
          [action.addressId]: {
            addressee: state.addresses[action.addressId].addressee,
            addressId: action.addressId,
            ...action.values,
            selectedAddressCategory: action.selectedAddressCategory,
          },
        },
      };
    case types.DELIVERY_ADDRESS_UPDATE_CONTACT_NUMBER:
      return {
        ...state,
        contactNumber: action.value,
      };
    case types.ADDRESS_UPDATE_CONTACT_NUMBER:
      return {
        ...state,
        addresses: {
          ...state.addresses,
          [action.addressId]: {
            ...state.addresses[action.addressId],
            contactNumber: action.contactNumber,
          },
        },
      };
    case types.SHOULD_SHOW_SPINNER:
      return {
        ...state,
        showSpinner: action.show,
      };
    case types.SET_ADDRESS_ENTRY_TYPE:
      return {
        ...state,
        entryType: action.entryType,
      };
    case types.ADDRESS_LOOKUP_USE_DELIVERY_RESULT:
      return {
        ...state,
        addresses: {
          ...state.addresses,
          '': {
            addressee: state.addresses[''].addressee,
            firstName: state.addresses[''].firstName || '',
            lastName: state.addresses[''].lastName || '',
            country: state.addresses[''].country,
            addressId: '',
            ...action.values,
            showLookupSelection: true,
          },
        },
        entryType: 'LOQATE',
      };
    case types.EXPRESS_CHECKOUT_RETURNED_ADDRESS:
      return {
        ...state,
        addresses: {
          ...state.addresses,
          '': {
            addressee: action.values.addressee,
            country: action.values.country,
            addressId: '',
            ...action.values,
          },
        },
      };
    case types.DELIVERY_ADDRESS_UPDATE_FIELD_OF_SELECTED_ADDRESS:
      return {
        ...state,
        addresses: {
          ...state.addresses,
          [state.addressId]: {...state.addresses[state.addressId], [action.name]: action.value},
        },
      };
    case types.UPDATE_RESIDENT_ID_PROPERTY:
      return {
        ...state,
        residentID: {
          ...state.residentID,
          [action.propName]: action.value,
        },
      };
    case types.POPULATE_NEW_ADDRESS_WITH_SELECTED_ADDRESS:
      return {
        ...state,
        addressId: '',
        addresses: {
          ...state.addresses,
          '': {
            ...state.addresses[state.addressId],
            addressId: '',
          },
        },
      };
    default:
      return state;
  }
};

export const selectDeliveryAddress = state => (
  state.addresses[state.selectedAddressId],
  state.addresses[state.selectedAddressCategory]
);

export default deliveryAddressListReducer;
